import { connect } from 'react-redux'
import ProviderProductDeleteModal from '../../components/products/ProviderProductDeleteModal'
import * as productActions from '../../state/actions/provider-products/index'
import { IProviderProductObject, IStoreState } from '../../types/index'

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  const product = state.providerProduct.deleteProductModal.product
  return {
    product,
    deleting: state.providerProduct.deleteProductModal.deleting,
    error: state.providerProduct.deleteProductModal.error
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    onCancelClick: () => {
      dispatch(productActions.actionCreators.productDeleteModalHide())
    },
    onDeleteClick: (product: IProviderProductObject) => {
      dispatch(productActions.removeProduct(product))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProviderProductDeleteModal)



// WEBPACK FOOTER //
// ./src/containers/products/ProviderProductDeleteModal.ts